import { Component, OnInit } from '@angular/core';
import { EmailsService } from '@app/core/services';

interface FooterMenu {
  title: string;
  path?: string;
  externalLink?: string;
  links?: {
    name: string;
    path?: string;
    icon?: string;
    href?: string;
    queryParams?: Object;
  }[];
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  isSubscribedSuccessfully: boolean;
  errorMessage: string;

  menus: FooterMenu[] = [
    {
      title: 'О платформе',
      path: '/about',
      links: [
        { name: 'Информация', path: '/about' },
        // { name: 'Вопросы и ответы', path: '/about', queryParams: { search: '' } },
      ],
    },
    {
      title: 'Помощь',
      externalLink: 'https://form.pamyatpokoleniy.ru/',
      // path: '/social-support',
      // links: [
      //   { name: 'Помощь юриста', path: '/social-support/consults' },
      //   { name: 'Помощь психолога', path: '/social-support/psycho-help' },
      //   { name: 'Помощь государства', path: '/social-support/services' },
      //   { name: 'Ветеранские организации', path: '/social-support/organizations' },
      //   { name: 'Помощь от волонтёра', path: '/social-support/help-from-volunteers' },
      //   { name: 'Помощь от фонда', path: '/social-support/help-from-fund' },
      // ],
    },
    {
      title: 'Новости',
      path: '/magazine',
      links: [
        { name: 'Новости', path: '/magazine/news' },
        // { name: 'Праздники и памятные даты', path: '/magazine/events' },
      ],
    },
    // {
    //   title: 'Скидки',
    //   path: '/stocks',
    //   links: [
    //     { name: 'Все скидки', path: '/stocks' },
    //     { name: 'Партнёрам', path: '/partner/instructions' },
    //   ],
    // },
    {
      title: 'Вакансии',
      externalLink: 'https://veterans.superjob.ru/',
    },
    {
      title: 'Отзывы',
      path: '/feedbacks',
    },
    // {
    //   title: 'Социальные сети',
    //   links: [
    //     { name: 'ВКонтакте', href: 'https://vk.com/pamyatpokoleniy', icon: '/assets/images/decoration-icons/vk-icon.svg' },
    //     { name: 'Одноклассники', href: 'https://ok.ru/pamyatpokoleniy',
    //       icon: '/assets/images/decoration-icons/odnoklassniki-icon.svg' },
    //   ],
    // }
  ];

  constructor(
    private emailsService: EmailsService,
  ) { }

  ngOnInit() {
  }

  subscribe(email: string) {
    if (!email) return;
    this.errorMessage = null;
    this.emailsService.createSubscription(email, 1)
      .subscribe(
        response => this.isSubscribedSuccessfully = true,
        error => {
          if (error.status === 400) {
            this.errorMessage = error.error && error.error.email;
          } else {
            this.errorMessage = `Не удалось совершить запрос. Попробуйте еще раз. (${error.status})`;
          }
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.ts